
import { Observable } from 'rxjs';
import { Parameter } from '../common/parameter';



export interface PatientMedicalHistoryParameter extends Parameter {
    searchTerm: number;
    orderBy: string;
}

export interface PatientFamilyMedicalHistory {
   
  regId: string;
  medicalHistoryId: string;
  tenantId: string;
  branchId: string;
  duration: number;
  period: string;
  notes: string;
  relationship: number;
  parameters?: PatientMedicalHistoryParameter[];
  links?: any;
  //log
  createdDate?:Date;
    updatedDate?:Date;
    createdBy?:number;
    updatedBy?:number;
    createdIP?:string;
    updatedIP?:string;

    // diabetes
    name?: string;
    age?: string;
    ageOnSet?: string;
    treatment?: string;
    complications?: string;
    Consanguinity?: string;
    
    visitId?: number;
    diseaseCategory?: string;
    paternalBrothersCount?: number;
    paternalBrothersNonCount?: number;
    maternalBrothersCount?: number;
    maternalBrothersNonCount?: number;

    paternalSistersCount?: number;
    paternalSistersNonCount?: number;
    maternalSistersCount?: number;
    maternalSistersNonCount?: number;

    patientBrothersCount?: number;
    patientBrothersNonCount?: number;
    patientSistersCount?: number;
    patientSistersNonCount?: number;

    paternalSide?: string;
    maternalSide?: string;
    overallDiabeticStatus?: string;
    ohaUse?: string;


}

export abstract class PatientFamilyMedicalHistoryData {
  abstract list(url: string): Observable<PatientFamilyMedicalHistory[]>;
  abstract create(url: string, data: PatientFamilyMedicalHistory): Observable<any>;
  abstract createForDia(url: string, data: any): Observable<any>;
  abstract update(url: string, data: PatientFamilyMedicalHistory): Observable<any>;
  abstract updateForDia(url: string, data: any): Observable<any>;
  abstract delete(url: string): Observable<any>;
}
